function debounce(callback, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(callback.apply(this, args), delay);
  };
}
const decounceQuickView1 = debounce(() => {
  document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
  if (BSS_B2B.qi.status === true) {
    BSS_B2B.observer.productSubject.initProductForm()
    BSS_B2B.qi.initFunction()
  }
}, 1000);

const decounceChangeVariantQuickView1 = debounce(() => {
  const productForm = document.querySelector("[bss-b2b-quickview-product-form]");
  BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
}, 1000);

const fixQuickView1 = () => {
  const targetNode = document.querySelector("quick-add-drawer");
  const config = { attributes: true, childList: true, subtree: true };
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class" &&
        mutation.target.className.includes("quick-add__product-details")
      ) {
        decounceQuickView1();
      } else if (
        mutation.type === "attributes" &&
        mutation.attributeName === "value"
      ) {
       decounceChangeVariantQuickView1()
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
};

document.addEventListener("DOMContentLoaded", function () {
    let quickAddDrawer = document.querySelector('.cart-drawer__summary ');
    console.log(quickAddDrawer);

    if (quickAddDrawer) {
        let observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                if (m.addedNodes.length) {
                  BSS_B2B.observer.cartSubject.listenCartCheckout() 
                }
            });
        });

        observer.observe(quickAddDrawer, {
            childList: true,
        });
    }
});

const fixTE1 = () => {
  const pageType =
    window.ShopifyAnalytics &&
    window.ShopifyAnalytics.meta &&
    window.ShopifyAnalytics.meta.page &&
    window.ShopifyAnalytics.meta.page.pageType;

  if (pageType !== "cart") {
    let counter = 0;
    const interval = setInterval(() => {
      const footerPrice = document.querySelector(".ajaxcart__footer-price");
      const taxExWrapper = document.querySelector(
        ".bss-b2b-tax-ex-wrapper.bss-config-header"
      );

      if (footerPrice && taxExWrapper) {
        footerPrice.parentNode.insertBefore(taxExWrapper, footerPrice);
        handleTEBox();
        clearInterval(interval);
      } else {
        counter += 100;
        if (counter >= 10000) {
          clearInterval(interval);
        }
      }
    }, 100);
  } else {
    let counter = 0;
    const interval = setInterval(() => {
      const vatInputWrapper = document.querySelector(
        ".bss-b2b-vat-input-wrapper"
      );

      if (vatInputWrapper) {
        handleTEBox();
        clearInterval(interval);
      } else {
        counter += 100;
        if (counter >= 10000) {
          clearInterval(interval);
        }
      }
    }, 100);
  }

  function handleTEBox() {
    const translations = BSS_B2B.te.teTranslations;
    const headerText = document.querySelector(
      ".bss-b2b-translation-vat-form_header_text"
    );
    if (headerText) {
      headerText.innerText = translations.form_header_text;
    }

    const subtitleText = document.querySelector(
      ".bss-b2b-translation-vat-form_subtitle_text"
    );
    if (subtitleText) {
      subtitleText.innerText = translations.form_subtitle_text;
    }

    const successMessages = [
      document.querySelector(".bss-b2b-translation-vat-form_success_message"),
      document.querySelector(
        ".bss-b2b-translation-vat-form_success_message_uk"
      ),
      document.querySelector(
        ".bss-b2b-translation-vat-form_success_message_abn"
      ),
      document.querySelector(
        ".bss-b2b-translation-vat-form_success_message_gst"
      ),
      document.querySelector(
        ".bss-b2b-translation-vat-form_success_message_us_ein"
      ),
    ];

    successMessages.forEach((msg, index) => {
      if (msg) {
        switch (index) {
          case 0:
            msg.innerText = translations.form_success_message || "";
            break;
          case 1:
            msg.innerText = translations.form_success_message_uk || "";
            break;
          case 2:
            msg.innerText = translations.form_success_message_abn || "";
            break;
          case 3:
            msg.innerText = translations.form_success_message_gst || "";
            break;
          case 4:
            msg.innerText = translations.form_success_message_us_ein || "";
            break;
        }
      }
    });

    const errorMessages = [
      document.querySelector(".bss-b2b-translation-vat-form_error_message"),
      document.querySelector(".bss-b2b-translation-vat-form_error_message_uk"),
      document.querySelector(".bss-b2b-translation-vat-form_error_message_abn"),
      document.querySelector(".bss-b2b-translation-vat-form_error_message_gst"),
      document.querySelector(
        ".bss-b2b-translation-vat-form_error_message_us_ein"
      ),
      document.querySelector(
        ".bss-b2b-translation-vat-form_validate_country_code_message"
      ),
    ];

    errorMessages.forEach((msg, index) => {
      if (msg) {
        switch (index) {
          case 0:
            msg.innerText = translations.form_error_message || "";
            break;
          case 1:
            msg.innerText = translations.form_error_message_uk || "";
            break;
          case 2:
            msg.innerText = translations.form_error_message_abn || "";
            break;
          case 3:
            msg.innerText = translations.form_error_message_gst || "";
            break;
          case 4:
            msg.innerText = translations.form_error_message_us_ein || "";
            break;
          case 5:
            msg.innerText =
              translations.form_validate_country_code_message || "";
            break;
        }
      }
    });
  }

  document.addEventListener("cart:rerendered", () => {
    if (BSS_B2B) {
      BSS_B2B.observer.cartSubject.listenCartCheckout();
    }
  });
};

const fixCart1 = async () => {
  const res = await BSS_B2B.storage.productStorage.load();
  if (res) {
    if (
      res.notExistProductIds?.length ||
      res.productIds?.length ||
      res.variantIds?.size
    ) {
      BSS_B2B.observer.productSubject.notifyObserver(
        "LazyProduct",
        "LoadedLazyProduct",
        {
          ...res,
        }
      );
    }
  }
};

const fixOrderNote1 = async () => {
  const customFields = document.querySelector(".bss-b2b-custom-fields");
  const cartSummary  = document.querySelector(".cart__summary ");

  if (customFields && cartSummary) {
    cartSummary.insertBefore(customFields, cartSummary.firstElementChild.nextSibling);
  }
}

let debounceTimer1;

function applyTemporaryStyle1() {
  clearTimeout(debounceTimer1);

  const styleId = 'bss-disable-checkout-style';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .bss-b2b-main-cart [name="checkout"] {
        pointer-events: none !important;
        opacity: 0.6 !important;
      }
    `;
    document.head.appendChild(style);
  }

  debounceTimer1 = setTimeout(() => {
    const existingStyle = document.getElementById(styleId);
    if (existingStyle) {
      existingStyle.remove();
    }
  }, 2639);
}


const isCart1 = window.location.pathname === '/cart';
document.addEventListener("DOMContentLoaded", (event) => {
  if(isCart1) {
    applyTemporaryStyle1();
  }
  if (BSS_B2B) {
    fixQuickView1();
    fixTE1();
    setTimeout(() => fixCart1(), 3000);
    fixOrderNote1()
  }

  let a = document.querySelectorAll('[class*="ai-fc-content-template"]')
  console.log(a)
  if (a.length) {
    a.forEach((e)=>{
      e.setAttribute('bss-b2b-feature-product-form' , '')
    })
  }

});

if(isCart1) {
  document.addEventListener("bss_b2b:CustomCartUpdate", e => {
    applyTemporaryStyle1();
  })
}
